export const MENU_ID = 'global-issue-navigator';
